export default "__VITE_ASSET__CAdrbzgA__"